export const TIMESCALE_METRICS = ['count_coldstart', 'count_retry', 'billed_duration', 'max_memory_used', 'percentage_memory_used', 'cost']
export const SLOTS = [60, 600, 3600, 86400]
